import { render, staticRenderFns } from "./AccountSettingsEditNameForm.vue?vue&type=template&id=04faf836&"
import script from "./AccountSettingsEditNameForm.vue?vue&type=script&lang=js&"
export * from "./AccountSettingsEditNameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports